import React, { useState, useEffect, useCallback } from "react";
import UserProfileComponent from "./UserProfileComponent";
//import * as moment from "moment";
import * as moment from 'moment-timezone'
import ChangePasswordComponent from "../components/Shared/ChangePasswordComponent";
import TabStorage from "../helper/TabStorage";
import { Icon } from "@iconify/react";

const TIME_FORMAT = "ddd DD, MMM h:mm:ss A";
//const TIME_ZONE_FORMAT = "America/New_York";

export default function HeaderComponent() {
  const [userSession, setUserSession] = useState([]);
  const [currentTime, setCurrentTime] = useState([]);

  const [state, setState] = useState({
    changePassword: {
      renderChangePasswordModal: false,
      userId: 0,
      userName: "",
    },
  });

  let isUseEffectRendered = false;
  useEffect(() => {
    const controller = new AbortController();
    try {
      if (isUseEffectRendered) {
        return;
      }

      var userData = TabStorage.getItem("user");
      var timezoneData = TabStorage.getItem("timezone");

      setUserSession(userData);
      setCurrentTime(moment().tz(timezoneData).format(TIME_FORMAT));
      callApi();
      return () => {
        controller.abort();
        isUseEffectRendered = true;
      };
    } catch (error) {
      console.log(error);
    }
  }, []);

  const callApi = useCallback(async () => {
    try {
      // var changePassword = {
      //   renderChangePasswordModal: false,
      //   userId: 0,
      //   userName: "",
      // }  
      // setChangePasswordModal(changePassword);

      setInterval(() => {
        setCurrentTime(moment().tz(TabStorage.getItem("timezone")).format(TIME_FORMAT))
      }, 1000);
    } catch (error) {
      console.log(error);
    }
  }, []);

  const handleOnClosePasswordUpdateModal = async () => {
    try {
      let changePassword = state.changePassword;
      changePassword.renderChangePasswordModal = false;
      changePassword.userId = 0;
      changePassword.userName = "";
      setState((prev) => ({ ...prev, changePassword: changePassword }));
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <nav className="main-header navbar navbar-expand navbar-white navbar-light">
        <ul className="navbar-nav">
          <li className="nav-item">
            <a
              className="nav-link pt-2"
              href="#"
              role="button"
              onClick={(e) => {
                e.preventDefault();
                window.dispatchEvent(new Event("toggle-sidebar"));
              }}
            >
              <i className="fas fa-bars" />
            </a>
          </li>
          <li className="nav-item">
            <h3 className="topbarheading" id="pageTitle"></h3>
          </li>
        </ul>

        <ul className="navbar-nav ml-auto">
          <li className="nav-item">
            <a className="nav-link">
              <Icon icon="ph:clock-light" width="16" height="16" />&nbsp;
              <span className="topbar-clock">{currentTime}</span>
            </a>
          </li>
          <li className="nav-item">
            <a
              className="nav-link dropdown-toggle"
              type="button"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <Icon icon="ph:user-circle-light" width="18" height="18" />
              &nbsp;
              {userSession.firstName + " " + userSession.lastName}
            </a>
            <div className="dropdown-menu dropdown-menu-right">
              <div className="seg-dd-header">
                <Icon icon="ph:user-circle-light" width="32" height="32" style={{ color: "#1e2d5f", flexShrink: 0 }} />
                <div>
                  <div className="seg-dd-name">{userSession.firstName + " " + userSession.lastName}</div>
                  <div className="seg-dd-role">{userSession.userTypeName}</div>
                </div>
              </div>
              <div className="seg-dd-divider" />
              <a
                className="seg-dd-item"
                href="#"
                onClick={(e) => {
                  const user = TabStorage.getItem("user");
                  e.preventDefault();
                  let changePassword = state.changePassword;
                  changePassword.renderChangePasswordModal = true;
                  changePassword.userId = user.userId;
                  changePassword.userName = user.userName;
                  setState((prev) => ({ ...prev, changePassword: changePassword }));
                }}
              >
                <Icon icon="ph:key-light" width="16" height="16" />
                Change Password
              </a>
              <div className="seg-dd-divider" />
              <a
                className="seg-dd-item seg-dd-logout"
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  TabStorage.clearSessionItems();
                  window.location.href = "/";
                }}
              >
                <Icon icon="ph:sign-out-light" width="16" height="16" />
                Logout
              </a>
            </div>
          </li>
        </ul>
      </nav>
      {state.changePassword.renderChangePasswordModal && (
        <ChangePasswordComponent
          userId={state.changePassword.userId}
          userName={state.changePassword.userName}
          onClose={handleOnClosePasswordUpdateModal}
        />
      )}
    </>
  );
}